import React from "react";

function GradianButton({ label, onClick }) {
  return (
    <>
      <button className="gradian-btn" onClick={() => onClick()}>
        <span class="relative px-[11px] py-2  bg-[#F5F6FA] rounded-[8px] flex items-center gap-[6px]">
          <svg
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 1.5V13.5"
              stroke="url(#paint0_linear_157_1826)"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1 7.5H13"
              stroke="url(#paint1_linear_157_1826)"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <defs>
              <linearGradient
                id="paint0_linear_157_1826"
                x1="7.325"
                y1="13.5"
                x2="7.325"
                y2="1.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#2E3E8D" />
                <stop offset="1" stop-color="#4DB1E1" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_157_1826"
                x1="4.9"
                y1="8.5"
                x2="4.9"
                y2="7.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#2E3E8D" />
                <stop offset="1" stop-color="#4DB1E1" />
              </linearGradient>
            </defs>
          </svg>

          <span class="bg-clip-text text-transparent bg-gradient-to-t from-[#2E3E8D] text-sm to-[#4DB1E1]">
            {label}
          </span>
        </span>
      </button>
    </>
  );
}

export default GradianButton;
